import React from 'react';
import { H1, H2 } from '@osmosis/tailwind-ui/components/Text';
import { getTextColor } from '../../../lib/composer/schemas/theme';
import { textColorClassMap } from '@osmosis/tailwind-ui/styles/text';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import { HeaderProps } from '../../../types/composer';

/** Render a generic heading. */
const Heading = (props: HeaderProps) => {
  const {
    theme = 'transparent',
    text,
    textProps = '',
    topHeader,
    alignment = 'center',
    textColor,
    fontSize = 'default',
    isWordPressBlock = false,
  } = props;
  const themeTextColor: string | undefined = getTextColor(theme);
  const textColorClass = textColor || textColorClassMap[themeTextColor];
  // Rending regular h1/h2 if a custom font size is provided so it doesn't get the default styling for H1/H2 from tailwind-ui.
  const Comp: React.ElementType = isWordPressBlock
    ? topHeader
      ? 'h1'
      : 'h2'
    : topHeader
      ? H1
      : H2;
  const id = topHeader ? 'h1-main-content' : 'h2-sub-content';

  return (
    <Comp
      data-testid={id}
      className={cn(
        textColorClass,
        textProps,
        `text-${alignment}`,
        fontSize !== 'default' && fontSize,
      )}
    >
      {isWordPressBlock && topHeader ? <strong>{text}</strong> : text}
    </Comp>
  );
};

Heading.displayName = 'Heading';
export default Heading;
